import { schema, types } from 'papr'

export const anonymousEmailOptoutsSchema = schema({
	email: types.string({ required: true }),
	dateAdded: types.date(),
	optouts: types.object({
		referrals: types.boolean(),
	}),
})

export type AnonymousEmailOptoutsDocument = (typeof anonymousEmailOptoutsSchema)[0]
export type AnonymousEmailOptoutsDefaults = (typeof anonymousEmailOptoutsSchema)[1]
